export default "__VITE_ASSET__CBPL8sC8__"